const Raptor = Mach.requireModule('Raptor');

export enum MULTI_SKU_MODAL_MONITOR_VALUE {
  FAILED = 0,
  SUCCESS = 1,
}

export class MutliSKUModalMonitor {
  /**
     * 通参
     */
  defaultTags = {
    osName: Mach.env.osName ?? '',
    osVersion: Mach.env.osVersion ?? '',
    appVersion: Mach.env.version ?? '',
    platform: Mach.env.isAndroid ? 'Android' : 'iOS',
  }

  /**
     * 采样率
     */
  sampleRate = 1.0;

  /**
     * 调起多规格菜品浮层成功率
     */
  multiSkuModalOpenRate = (value: MULTI_SKU_MODAL_MONITOR_VALUE, params) => {
    const tags = { ...this.defaultTags, ...params, status: value };
    this.reportMetrics({ MultiSkuModalOpenRate: value }, tags);
  }

  /**
     * 菜品浮层precheck成功率
     */
  multiSkuModalPrecheckRate = (value: MULTI_SKU_MODAL_MONITOR_VALUE, params) => {
    const tags = { ...this.defaultTags, ...params, status: value };
    this.reportMetrics({ MultiSkuModalPrecheckRate: value }, tags);
  }

  /**
     * 订单预览Preview成功率
     */
  multiSkuModalPreviewRate = (value: MULTI_SKU_MODAL_MONITOR_VALUE, params) => {
    const tags = { ...this.defaultTags, ...params, status: value };
    this.reportMetrics({ MultiSkuModalPreviewRate: value }, tags);
  }

  /**
     * 上报Report监控指标
     * @param params
     * @param tags
     */
  reportMetrics = async (params, tags) => {
    const envName = Mach.env.isDebug ? 'Test' : 'Prod';
    const tagsObj = { ...tags, env: envName };
    // 校验tag数据是否为字符串
    const tagParams = this.checkAndConvertToString(tagsObj);
    Raptor?.reportMetrics?.(params, tagParams, this.sampleRate);
  }

  /**
     * 检查Value类型是否为字符串并转换
     * @param obj
     * @returns
     */
  checkAndConvertToString = (obj) => {
    if (Array.isArray(obj) || typeof obj !== 'object') {
      return obj;
    }
    const convertObj = {};
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        if (typeof obj[key] === 'string') {
          convertObj[key] = obj[key];
        } else if (typeof obj[key] === 'number') {
          convertObj[key] = String(obj[key]);
        }
      }
    }
    return convertObj;
  }
}
